module.exports = __webpack_public_path__ + "img/TR.9aefdc99.svg";